import { isRouteErrorResponse } from 'react-router';

function describeNonError(value: unknown): string {
  try {
    if (typeof value !== 'object' || value === null) {
      return `thrown ${typeof value}`;
    }

    const plain: unknown = 'toJSON' in value && typeof value.toJSON === 'function' ? value.toJSON() : value;
    if (typeof plain !== 'object' || plain === null) {
      return 'thrown object';
    }

    const status = 'status' in plain ? plain.status : undefined;
    const code = 'code' in plain ? plain.code : undefined;
    const parts = [
      typeof status === 'number' || typeof status === 'string' ? `status ${status}` : '',
      typeof code === 'string' ? code : '',
    ].filter(Boolean);
    if (parts.length > 0) {
      return parts.join(' ');
    }

    const keys = Object.keys(plain).slice(0, 5);
    return keys.length > 0 ? `thrown object with keys ${keys.join(', ')}` : 'thrown object';
  } catch {
    return 'thrown value';
  }
}

export function wrapRouteError(error: unknown) {
  if (isRouteErrorResponse(error)) {
    const responseError = new Error(`${error.status} ${error.statusText}`);
    responseError.name = 'ReactRouterResponseError';
    responseError.cause = error;

    return responseError;
  }

  const routeError = new Error();
  if (error instanceof Error) {
    routeError.message = error.message;
    routeError.stack = error.stack;
  } else {
    routeError.message = describeNonError(error);
  }
  routeError.name = 'ReactRouterError';
  routeError.cause = error;

  return routeError;
}
